<div class="option-content-particularity pointer" (click)="setIsAvBusiness()">
    <span class="option-title">{{ label }}</span>

    <div class="actions">
        <input type="checkbox" [checked]="isAvBusiness" class="checkbox"/>
    </div>
</div>
